webpackJsonp([5],{

/***/ 203:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Iframe_vue__ = __webpack_require__(348);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7264ccf2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Iframe_vue__ = __webpack_require__(373);
function injectStyle (ssrContext) {
  __webpack_require__(371)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Iframe_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7264ccf2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Iframe_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import api from '../../../api'
// import { EventBus } from '../../core/event-bus.js'
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProyectoIframe',
  props: ['codigo_proyecto', 'index'],
  data: function data() {
    return {
      data: null,
      error: null,
      loading: true
    };
  },
  mounted: function mounted() {
    var vm = this;
    setTimeout(function () {
      var proyecto = vm.$store.getters.getProyectoPorCodigo(vm.codigo_proyecto);
      if (proyecto) {
        vm.data = proyecto.simaapplink[vm.index];
        vm.loading = false;
      } else {
        vm.error = 'No existe el proyecto o el iframe';
        vm.loading = false;
      }
    }, 1000);
  }
});

/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(372);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(198)("1a758578", content, true, {});

/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(197)(true);
// imports


// module
exports.push([module.i, "iframe{border:1px solid #d2d6de}", "", {"version":3,"sources":["D:/laragon/www/sima/simaapp-web/src/components/views/proyectos/Iframe.vue"],"names":[],"mappings":"AACA,OACE,wBAA0B,CAC3B","file":"Iframe.vue","sourcesContent":["\niframe {\r\n  border: 1px solid #d2d6de;\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 373:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('bounce-loader',{attrs:{"loading":_vm.loading}}),_vm._v(" "),(_vm.data)?_c('iframe',{attrs:{"width":"100%","height":"100%","src":_vm.data.cta_link_or_iframe_src}}):_vm._e(),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h1',{staticClass:"pull-left",attrs:{"id":"proy-code"}},[_vm._v(_vm._s(_vm.codigo_proyecto))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 text-center"},[_vm._v("\n      "+_vm._s(_vm.error)+"\n    ")])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/5.43d387f22c09dae96766.js